import React from 'react'
import { UploadElement } from 'is24-corecss'
import { useTranslation } from 'react-i18next'
import { IconS24Picture24 } from '@is24/cosma-ui-icons'
import { AiDataExtractionUploadError } from './AiDataExtractionUploadError'

interface AiEmptyUploadImageSectionProps {
  errorText?: string
  onAddClick?: () => void
  onFileSelect: (files: FileList | null) => void
}

export const AiEmptyUploadImageSection = ({ errorText, onAddClick, onFileSelect }: AiEmptyUploadImageSectionProps) => {
  const { t } = useTranslation()
  const uploadError = errorText ? <AiDataExtractionUploadError message={errorText} /> : null

  return (
    <section className='margin-bottom-l'>
      <h3 className='font-body-medium-bold margin-bottom-s'>{t('wizard.uploadAiBanner.modal.photos.sectionTitle')}</h3>
      <div data-testid='ai-upload-photos-tile' onClickCapture={onAddClick}>
        <UploadElement.Root onFileSelect={onFileSelect} status='empty' accept='image/jpeg,image/png' multiple>
          <UploadElement.Dropzone>
            <UploadElement.Icon>
              <IconS24Picture24 />
            </UploadElement.Icon>
            <UploadElement.Content>
              <UploadElement.Title>{t('wizard.uploadAiBanner.modal.photos.tileTitle')}</UploadElement.Title>
              <UploadElement.Description>
                {t('wizard.uploadAiBanner.modal.photos.supportText')}
              </UploadElement.Description>
            </UploadElement.Content>
          </UploadElement.Dropzone>
        </UploadElement.Root>
        {uploadError ? <div className='margin-top-s'>{uploadError}</div> : null}
      </div>
    </section>
  )
}
